import gql from 'graphql-tag';

export default gql`
    mutation DeleteLofa($input: LofaDeleteRequest) {
        deleteLofa(input: $input) {
            errors
        }
    }
`;
